import { ButtonList, Divider } from '@busybusy/webapp-react-ui';
import { HeadsetIcon } from 'assets/icons';
import { HeaderDialog } from 'components';
import { useOpenable } from 'hooks';
import useNavListGraylog from 'hooks/analytics/useNavListGraylog';

import { t } from 'utils/localize';
import FakeNavItem from '../FakeNavItem/FakeNavItem';
import CustomerSupportActionList from '../NavHeader/CustomerSupportActionList/CustomerSupportActionList';
import NavSection from '../NavSection/NavSection';
import useNavBarSettings from '../hooks/useNavBarSettings';

const NavList = () => {
  const { getVisibleNavBarSettings } = useNavBarSettings();
  const { general: top, reports, misc: bottom } = getVisibleNavBarSettings();

  const customerSupportOpenable = useOpenable();
  const userEvents = useNavListGraylog();

  function handleSupportClick() {
    userEvents.recordClickSupport();
    customerSupportOpenable.open();
  }

  return (
    <ButtonList>
      {top.length > 0 && (
        <>
          <NavSection configuration={top} isMin={false} />
          {reports.length > 0 && bottom.length > 0 && <Divider />}
        </>
      )}

      {reports.length > 0 && (
        <>
          <h3 className="no-text-select">{t('Reports')}</h3>
          <NavSection configuration={reports} isMin={false} />
          {bottom.length > 0 && <Divider />}
        </>
      )}

      <h3 className="no-text-select">{t('Misc')}</h3>
      {bottom.length > 0 && (
        <>
          <NavSection configuration={bottom} isMin={false} />
        </>
      )}

      <FakeNavItem onClick={handleSupportClick} icon={HeadsetIcon}>
        {t('Support')}
      </FakeNavItem>

      <HeaderDialog
        title={t('Support')}
        isOpen={customerSupportOpenable.isOpen}
        onClose={customerSupportOpenable.close}
      >
        <CustomerSupportActionList onSelect={customerSupportOpenable.close} className="mx-8 mb-6 pt-2" />
      </HeaderDialog>
    </ButtonList>
  );
};

export default NavList;
